module.exports = __webpack_public_path__ + "static/img/scc.39bf231.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/scc.png
// module id = uzdu
// module chunks = 1